import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios'
import BootSpinner from '@/components/Spinner/BootSpinner'
import FrenteLoja from '@/views/FrenteLoja'
import { setMeta, defaultMeta, seoPrefMeta } from '@/mixins/meta'

store.$http = axios.create({ baseURL: process.env.NODE_ENV !== 'production' ? 'https://localhost:21158/api' : 'https://enobairro.com/api', withCredentials: true })

async function Boot() {
  createApp(BootSpinner).mount('#app')
  let loaded = await store.dispatch('Boot', window.location.href)
  if(loaded) {
    // Metatags padrão da loja a cada troca de rota; views (ex.: produto) podem sobrescrever com setMeta
    router.afterEach((to) => {
      setMeta(defaultMeta(store.getters.Empresa))
      if(to.path === '/inicio') setMeta({ title: 'próximo passo' })
      if(to.path === '/loja' || to.path === '/site') setMeta(seoPrefMeta(store.getters.Prefes, 'SeoPaginaPrincipal'))
      // na raiz: frente de loja se estiver ativa, senão a loja
      if(to.path === '/') setMeta(seoPrefMeta(store.getters.Prefes, store.getters.Empresa.frenteloja ? 'SeoFrenteLoja' : 'SeoPaginaPrincipal'))
      if(to.path === '/login') setMeta(seoPrefMeta(store.getters.Prefes, 'SeoLogin'))
    })

    if(!store.getters.Empresa.frenteloja) {
      router.addRoute({
        name: 'Frente de loja',
        path: '/desativado',
        component: FrenteLoja
      })
    }
    createApp(App).use(router).use(store).mount('#app')
  }
}

Boot()
